/* eslint-disable @typescript-eslint/no-explicit-any */
import { put, select } from 'redux-saga/effects'
import { Map, BuilderUiPersistenceState } from 'features/maps/types'
import {
  setControlsPaneOpen,
  setDescriptionOpen,
  setDescriptionPreview,
  setRightPaneTab,
  showGlobalBuilderError
} from './builderSlice'
import { loadMapSettings } from './mapSettingsSagas'
import { setCommentsVisible } from './mapCommentsSlice'

export function* loadPersistentUiStatePreLoad(currentMap: Map) {
  try {
    const uiState = currentMap.keplerMapConfig?.config?.uiState

    yield loadMapSettings(currentMap)

    if (currentMap.description && uiState?.descriptionOpen) {
      yield put(setDescriptionOpen(true))
    }
  } catch (e: any) {
    yield put(showGlobalBuilderError(e.message))
  }
}

export function* loadPersistentUiStatePostLoad(currentMap: Map) {
  try {
    const uiState = currentMap.keplerMapConfig?.config?.uiState

    if (uiState) {
      yield put(setDescriptionPreview(uiState.descriptionPreview))
      yield put(setControlsPaneOpen(uiState.controlsPaneOpen))
      if (uiState.controlsPaneTab) {
        yield put(setRightPaneTab(uiState.controlsPaneTab))
      }
      if (uiState.commentsVisible !== undefined) {
        yield put(setCommentsVisible(uiState.commentsVisible))
      }
    }
  } catch (e: any) {
    yield put(showGlobalBuilderError(e.message))
  }
}

export function* getPersistentUiState() {
  try {
    const { descriptionOpen, descriptionPreview, controlsPaneOpen, controlsPaneTab } = yield select(
      (state) => state.builder
    )
    return { descriptionOpen, controlsPaneOpen, descriptionPreview, controlsPaneTab } as BuilderUiPersistenceState
  } catch (e: any) {
    yield put(showGlobalBuilderError(e.message))
  }
}
